/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Action_CreateInputs */

const cs_ebr_action_create = /** @type {(inputs: Ebr_Action_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nové`)
};

const en_ebr_action_create = /** @type {(inputs: Ebr_Action_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Ebr_Action_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_action_create = /** @type {((inputs?: Ebr_Action_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Action_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_action_create(inputs)
	return cs_ebr_action_create(inputs)
});